import { Component, inject } from '@angular/core';
import { routes } from 'src/routes';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { AssetService, PagesV2Module } from '@schenck/rotec-components';
import { AssetToastService } from 'src/services';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { TranslateDirective } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

/**
 * Navigation component.
 */
@Component({
  selector: 'am-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.less'],
  imports: [PagesV2Module, RouterLinkActive, RouterLink, TranslateDirective, AsyncPipe],
})
export class PagesComponent {
  private readonly assetService = inject(AssetService);
  private readonly assetToastService = inject(AssetToastService);

  assetsLink = routes.assets.absoluteUrl;
  groupsLink = routes.groups.absoluteUrl;
  plantsLink = routes.plants.absoluteUrl;
  serviceHelpDeskLink = routes.serviceHelpDesk.absoluteUrl;

  nrOfAssets$ = combineLatest([this.assetService.machines$, this.assetService.toolings$]).pipe(
    map(([machines, toolings]) => {
      return (
        machines.filter((machine) => !machine.isDeactivated).length +
        toolings.filter((tooling) => !tooling.isDeactivated).length
      );
    })
  );

  nrOfGroups$ = this.assetService.machineGroups$.pipe(map((groups) => groups.length));
  nrOfPlants$ = this.assetService.plants$.pipe(map((plants) => plants.length));
}
